import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { useDocumentPage } from "../api/documents";

/**
 * "Referenced by": the documents whose body links to this one
 * (`documents.list {backlinkDocumentId}`). Absent entirely when nothing does.
 */
export function Backlinks({ documentId }: { documentId: string }): ReactNode {
  const page = useDocumentPage(
    "documents.list",
    { backlinkDocumentId: documentId, limit: 25 },
    documentId !== "",
  );
  const documents = page.data?.documents ?? [];
  if (documents.length === 0) return null;

  return (
    <section aria-labelledby="backlinks-heading" className="mt-10 border-t border-line pt-4">
      <h2
        id="backlinks-heading"
        className="text-xs font-semibold tracking-wide text-muted uppercase"
      >
        Referenced by
      </h2>
      <ul aria-label="Referenced by" className="mt-2 flex flex-col gap-1">
        {documents.map((document) => (
          <li key={document.id}>
            <Link to={document.url} className="text-sm text-accent hover:underline">
              {document.title === "" ? "Untitled" : document.title}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
